<script>
  import { _ } from "@services/i18n";
  import { currentUser } from "@stores/auth";
  import { showUserSheet } from "@stores/sheets";
  import Actions from "@components/Actions";
  import SignInForm from "@components/SignInForm";
  import SignOutButton from "@components/SignOutButton";
  import TextButton from "@components/TextButton";
  import Sheet, { SHEET_POSITIONS } from "@components/Sheet";

  let displayName = "";
  let mode;
  let signedOutTitle = $_("components.user_button.signed_out_title", {
    default: "Create an account"
  });

  $: signedIn = Boolean($currentUser);

  $: if (signedIn) {
    if ($currentUser.profile) {
      displayName = $currentUser.profile.displayName || "";
    } else {
      displayName = $currentUser.displayName || "";
    }
  } else {
    displayName = "";
  }

  $: signedInTitle = $_("components.user_button.signed_in_title", {
    default: "Signed in{nameLength, plural, =0 {} other { as {name}}}.",
    values: {
      name: displayName,
      nameLength: displayName.length
    }
  });

  /**
   * Toggles showUserSheet state
   */
  function toggleUserSheet() {
    showUserSheet.update(shown => !shown);
  }
</script>

<style>
  .user {
    background: url("/images/unauthenticated-user.svg") no-repeat center center;
    background-size: 100%;
    border: 0;
    cursor: pointer;
    height: 4.8rem;
    left: 1rem;
    margin: 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    top: 1rem;
    width: 4.8rem;
    z-index: 3;
  }

  .signedIn {
    background-image: url("/images/authenticated-user.svg")
  }

  span {
    overflow: hidden;
    position: absolute;
    text-indent: 100%;
    white-space: nowrap;
  }
</style>

<button
  class="user"
  class:signedIn
  data-testid="user-button"
  on:click|preventDefault|stopPropagation={toggleUserSheet}
  type="button"
>
  <span>
    {
      signedIn
        ? signedInTitle
        : signedOutTitle
    }
  </span>
</button>

{#if $showUserSheet}
  {#if $currentUser}
    <Sheet position={SHEET_POSITIONS.CENTER} hideTitle={!signedInTitle.length}>
      <p>{signedInTitle}</p>
      <Actions>
        <SignOutButton />
        <TextButton bold={true} color="var(--secondary-color)" on:click={toggleUserSheet} size="1.6rem">
          {
            $_("components.close_button.text", { default: "Close" })
          }
        </TextButton>
      </Actions>
    </Sheet>
  {:else}
    <Sheet position={SHEET_POSITIONS.CENTER}>
      <div slot="title">{signedOutTitle}</div>
      <SignInForm bind:mode bind:title={signedOutTitle} on:close={toggleUserSheet} on:success={() => window.location.reload()} />
    </Sheet>
  {/if}
{/if}
